import React from 'react'
import styled from 'styled-components'

const Img = styled.img`
`

const Cover = ({ src, alt,  }) => {
  return (
    <Img
      src={src}
      alt={alt}
    />
  )
}

export default Cover